import React, { useState } from 'react';
import { RaisedButton } from 'material-ui';
import api from 'services';

function PredictorType(props) {

    const [type, setType] = useState('');
    const [isLoading, setIsLoading] = useState(false);

    async function getPredictorType(text) {
        setIsLoading(true);
        const type = await api.fetchPredictorType(text);
        if (type.status === 200) {
            setType(type.data);
        } else {
            setType('Error')
        }
        setIsLoading(false);
    }

    return (
        <span style={{marginLeft: 10}}>
            <RaisedButton 
                className='btn'
                labelStyle={{ fontSize: '10px', color: 'white' }}
                style={{ height: '25px', margin: '10px 10px 10px 0' }}
                buttonStyle={{ height: '25px', lineHeight: '25px', backgroundColor: '#B26E63' }}
                label='Predictor type'
                onClick={() => getPredictorType(props.text)}
                disabled={isLoading}
            />
            <span>{type}</span>
        </span>
    );
}

export default PredictorType;



// WEBPACK FOOTER //
// ./app/components/Letters/Single/Gazetter/PredictorType.jsx